import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

export const useUpsAgreement = () => {
  const team = useRequiredContext(TeamContext);

  // Check if UPS agreement has been accepted
  const hasAcceptedUpsAgreement =
    team?.settings?.outboundLabels?.hasAcceptedUpsAgreement ?? false;

  return {
    shouldShowUpsAgreementLink: !hasAcceptedUpsAgreement,
    isButtonDisabledByUpsAgreement: !hasAcceptedUpsAgreement,
  };
};
